//@flow
/**
 * Question reducer
 * @module question/reducer
 */
import { Record, Map, Set, List, fromJS } from 'immutable'

export const FETCH_QUESTION_REQUEST = 'FETCH_QUESTION_REQUEST'
export const FETCH_QUESTION_PENDING = 'FETCH_QUESTION_PENDING'
export const FETCH_QUESTION_SUCCESS = 'FETCH_QUESTION_SUCCESS'
export const FETCH_QUESTION_FAILURE = 'FETCH_QUESTION_FAILURE'

export const PRELOAD_QUIZ_PATH = 'PRELOAD_QUIZ_PATH'

type Action =
  | { type: 'FETCH_QUESTION_REQUEST', payload: string }
  | { type: 'FETCH_QUESTION_PENDING', payload?: Question }
  | { type: 'FETCH_QUESTION_SUCCESS', payload: Question }
  | { type: 'FETCH_QUESTION_FAILURE', payload: Error, error: true }
  | { type: 'PRELOAD_QUIZ_PATH', payload: Array<string> }

const QuestionsRecord = Record({
  questions: Map(),
  requested: Set(),
  preloadPath: List(),
})

/**
 * handles storing and fetching of question data
 * @memberof question/reducer
 */
export default function QuestionsReducer(
  state: QuestionsRecord = new QuestionsRecord(),
  action: Action,
): QuestionsRecord {
  switch (action.type) {
    case FETCH_QUESTION_REQUEST: {
      const questionId = action.payload
      return state.update('requested', requested => requested.add(questionId))
    }

    case FETCH_QUESTION_PENDING:
      if (action.payload == null) {
        return state
      } else {
        const { id: questionId } = action.payload,
          question = fromJS(action.payload)
        return state.setIn(['questions', questionId], question)
      }

    case FETCH_QUESTION_SUCCESS: {
      const { id: questionId } = action.payload,
        question = fromJS(action.payload)
      return state.setIn(['questions', questionId], question)
    }

    case PRELOAD_QUIZ_PATH: {
      const preloadPath = action.payload
      return state.set('preloadPath', fromJS(preloadPath))
    }

    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/questions/reducer.js